import { Link } from "react-router-dom";

export default function Logo({ className = "", to = "/", variant = "auto", size = "md" }) {
  const src = variant === "white" ? "/coinbuy-logo-white.png" : "/coinbuy-logo.png";
  const heights = { sm: "h-7", md: "h-9", lg: "h-12" };
  const img = (
    <img
      src={src}
      alt="Coinbuy.org"
      data-testid="coinbuy-logo"
      className={`${heights[size] || heights.md} w-auto select-none ${className}`}
      draggable="false"
    />
  );
  return to ? (
    <Link to={to} className="inline-flex items-center">
      {img}
    </Link>
  ) : (
    img
  );
}
